import { AfterViewInit, Component, ElementRef, EventEmitter, Inject, Input, OnChanges, OnInit, Output, PLATFORM_ID, SimpleChanges, ViewChild } from '@angular/core';
import { EYesNo } from '../../../../../shared/models/types.enum';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { DateUtils } from '../../../../../shared/helpers/dateUtils';
import { ReviewRoarComponent } from '../../../../components/review-content/review-roar/review-roar.component';

@Component({
  selector: 'activity-details',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    ReviewRoarComponent
  ],
  templateUrl: './activity-details.component.html',
  styleUrl: './activity-details.component.css'
})
export class ActivityDetailsComponent implements OnInit, OnChanges, AfterViewInit {

  @Input() roarAssignmentFormData: any;
  @Output() onSaveSection1 = new EventEmitter<any>();

  @ViewChild('datepickerActivityActivityDate') datepickerActivityActivityDate!: ElementRef;
  
  yesNo = EYesNo;
  roarDetailsForm: FormGroup = new FormGroup([]);
  questionList = [
    {
      question: "Duration: *",
      formControlName: "activity_duration",
      type: "text"
    },
    {
      question: "Please provide all relevant details for this activity including, if applicable, indicators and an estimation of whether this was a successful intervention: *",
      formControlName: "details",
      type: "textarea"
    },
  ]

  constructor(
    @Inject(PLATFORM_ID) private platformId: object
  ) {}

  ngOnInit() {
    this.initializeForm();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['roarAssignmentFormData'] && this.roarAssignmentFormData) {
      this.initializeForm();
    }
  }

  private initializeForm() {
    const group: any = {};
    
    this.questionList.forEach(question => {
      group[question.formControlName] = new FormControl(this.roarAssignmentFormData?.[question.formControlName] || '', Validators.required);
    });
    
    group['roar_activity_date'] = new FormControl(this.roarAssignmentFormData?.roar_activity_date || DateUtils.formatDateForBackend(DateUtils.getCurrentFormattedDate()), Validators.required);
    group['roar_activity_time'] = new FormControl(this.roarAssignmentFormData?.roar_activity_time || '11:00', Validators.required);

    this.roarDetailsForm = new FormGroup(group);
  }  

  async ngAfterViewInit(): Promise<void> {
    if (isPlatformBrowser(this.platformId)) {
      // Dynamically import the Datepicker to avoid server-side loading
      const { Datepicker } = await import('flowbite-datepicker');
      if (this.datepickerActivityActivityDate) {
        new Datepicker(this.datepickerActivityActivityDate.nativeElement, {
          autohide: true,
          format: 'mm/dd/yyyy'
        });
        // set default value to display for incident date
        if (this.roarAssignmentFormData?.roar_activity_date) {
          // if date_of_incident is available, set it to the datepicker
          this.datepickerActivityActivityDate.nativeElement.value = DateUtils.formatDateForDisplay(this.roarAssignmentFormData.roar_activity_date);
        } else {
          // if date_of_incident is not available, set it to the current date
          this.datepickerActivityActivityDate.nativeElement.value = DateUtils.getCurrentFormattedDate();
        }
        this.datepickerActivityActivityDate.nativeElement.addEventListener('changeDate', (event: any) => {
          const formattedDate = DateUtils.formatDateForBackend(event.target.value);
          this.roarDetailsForm.get('roar_activity_date')?.setValue(formattedDate);
        });
      }
    }
  }

  saveRoarDetails(): void {
    if (this.roarDetailsForm.valid) {
        this.onSaveSection1.emit(this.roarDetailsForm.value);
    }
  }

}
